import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=47567624&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=47567624&prod&scoped=true&lang=css"
import style1 from "./CodeBlock.vue?vue&type=style&index=1&id=47567624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47567624",
  null
  
)

export default component.exports